/*
 * FMD Buy Box — Quick-Add modal override (DESKTOP ONLY)
 *
 * Replaces the generic Quick-Add modal body (assets/dk-quick-add-modal.js)
 * with a dedicated buy box for the two 5-Day FMD products:
 *   • prolon-offer        — flavor picker + Subscribe & Save / One-time
 *   • prolon-next-gen-v4  — single flavor, Subscribe & Save / One-time
 *
 * It registers itself through window.DK_QUICK_ADD_OVERRIDES, so the modal
 * renders this layout directly instead of the default one (no flash / swap).
 * Every other product keeps the default modal, and below the desktop
 * breakpoint the override bows out and the default modal is used everywhere.
 */
(function () {
  'use strict';

  // Matches the 768px breakpoint the Quick-Add modal itself uses.
  var DESKTOP_MQ = '(min-width: 768px)';

  // Titles shown in the buy box when the raw product title is too terse.
  var DISPLAY_TITLE = {
    'prolon-offer': 'Prolon 5-Day Fasting Mimicking Diet',
    'prolon-offer-24': 'Prolon 5-Day Fasting Mimicking Diet',
    'prolon-next-gen-v4': 'Prolon 5-Day FMD — Next Gen'
  };

  var RATING_TEXT = '4.4 · 1M+ Happy Healthy Customers';

  // Keyed by product handle. flavOrder also controls which flavors show and in
  // what order; anything not listed here is hidden from the buy box.
  var CONFIG = {
    'prolon-offer': {
      flavOrder: ['Original', 'Gen3', 'Expanded Variety', 'Next Gen', 'Next Gen Complete'],
      flavLabel: { 'Gen3': 'Bold Flavors' },
      flavDesc: {
        'Original': 'Classic powdered soups — mix, heat, enjoy',
        'Gen3': 'New bold soup flavors like Curry & Ginger',
        'Expanded Variety': 'Mix of soups, bars & shake',
        'Next Gen': 'Ready-to-eat organic soups (premium)',
        'Next Gen Complete': ''
      },
      defFlav: 'Expanded Variety'
    },
    'prolon-next-gen-v4': {
      flavOrder: ['Next Gen'],
      flavLabel: {},
      flavDesc: { 'Next Gen': 'Ready-to-eat organic soups (premium)' },
      defFlav: 'Next Gen'
    }
  };

  // ─── Styling ────────────────────────────────────────────────────────────────
  var STYLE = [
    '#cf-modal-container.igbb-host { max-width: 900px; }',
    '.igbb { display: grid; grid-template-columns: 300px 1fr; grid-template-rows: 1fr auto; color: #1E4036; }',
    '.igbb__img { grid-row: 1 / span 2; padding: 22px 18px; background: #F2EAE5; display: flex; align-items: center; justify-content: center; overflow: hidden; }',
    // `contain`, not `cover`: the column runs the full height of a tall modal,
    // so cover would crop the product shot down to a narrow strip.
    '.igbb__img img { width: 100%; height: auto; max-height: 100%; object-fit: contain; display: block; }',
    '.igbb__col { padding: 26px 26px 4px; display: flex; flex-direction: column; gap: 14px; }',
    '.igbb__head { display: flex; align-items: center; gap: 12px; padding-right: 40px; }',
    '.igbb__thumb { display: none; }',
    '.igbb__title { font-size: 21px; font-weight: 700; line-height: 1.25; }',
    '.igbb__rating { display: flex; align-items: center; gap: 6px; margin-top: 5px; font-size: 12.5px; opacity: 0.85; }',
    '.igbb__stars { color: #f5a623; letter-spacing: 1px; }',
    '.igbb__price { display: flex; align-items: baseline; gap: 8px; }',
    '.igbb__price .lbl { font-size: 11.5px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #6b7280; }',
    '.igbb__price .cap { font-size: 14px; color: #9ca3af; text-decoration: line-through; }',
    '.igbb__price .cur { font-size: 24px; font-weight: 700; }',
    '.igbb__h { margin-bottom: -6px; font-size: 11.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: #6b7280; }',
    '.igbb__flavs, .igbb__offers { display: flex; flex-direction: column; gap: 8px; }',
    '.igbb__row { display: flex; flex-wrap: wrap; align-items: flex-start; gap: 10px; padding: 11px 13px; border: 1.5px solid #d1d5db; border-radius: 10px; background: #fff; cursor: pointer; transition: border-color 0.15s, box-shadow 0.15s, background 0.15s; }',
    '.igbb__row:hover { border-color: #1E4036; }',
    '.igbb__row.sel { border-color: #1E4036; background: #f7faf8; box-shadow: inset 0 0 0 1px #1E4036; }',
    '.igbb__row:focus-visible, .igbb__rc:focus-visible { outline: 2px solid #1E4036; outline-offset: 2px; }',
    '.igbb__radio { position: relative; flex: 0 0 auto; width: 16px; height: 16px; margin-top: 2px; border: 1.5px solid #9ca3af; border-radius: 50%; }',
    '.igbb__row.sel .igbb__radio { border-color: #1E4036; }',
    ".igbb__row.sel .igbb__radio::after { content: ''; position: absolute; inset: 3px; border-radius: 50%; background: #1E4036; }",
    '.igbb__rc { flex: 1 1 auto; min-width: 0; }',
    '.igbb__rt { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; font-size: 14px; font-weight: 700; }',
    '.igbb__rd { margin-top: 2px; font-size: 12.5px; line-height: 1.45; opacity: 0.75; }',
    '.igbb__from { flex: 0 0 auto; align-self: center; font-size: 12.5px; font-weight: 600; color: #6b7280; white-space: nowrap; }',
    '.igbb__badge { padding: 3px 7px; border-radius: 9999px; background: #56a512; color: #fff; font-size: 9.5px; font-weight: 800; letter-spacing: 0.08em; }',
    '.igbb__save { margin-top: 3px; font-size: 12.5px; font-weight: 600; color: #56a512; }',
    '.igbb__save .cap { margin-right: 6px; font-weight: 500; color: #9ca3af; text-decoration: line-through; }',
    '.igbb__checks { list-style: none; margin: 8px 0 0; padding: 0; display: flex; flex-direction: column; gap: 4px; }',
    '.igbb__checks li { position: relative; padding-left: 18px; font-size: 12.5px; line-height: 1.4; opacity: 0.85; }',
    ".igbb__checks li::before { content: ''; position: absolute; left: 2px; top: 4px; width: 9px; height: 5px; border-left: 2px solid #56a512; border-bottom: 2px solid #56a512; transform: rotate(-45deg); }",
    '.igbb__freq { flex: 0 0 100%; margin: 10px 0 0 26px; }',
    '.igbb__freq select { width: 100%; padding: 9px 36px 9px 14px; border: 1.5px solid #d1d5db; border-radius: 8px; background-color: #fff; font-size: 13px; color: #1E4036; cursor: pointer; appearance: none; -webkit-appearance: none; background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%231E4036\' stroke-width=\'2.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpath d=\'m6 9 6 6 6-6\'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 14px center; }',
    '.igbb__freq select:focus { outline: none; border-color: #1E4036; }',
    '.igbb__foot { grid-column: 2; padding: 12px 26px 22px; display: flex; flex-direction: column; gap: 10px; }',
    '.igbb__cta { width: 100%; padding: 14px 24px; border: none; border-radius: 9999px; background: #56a512; color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.06em; cursor: pointer; transition: background 0.2s; }',
    '.igbb__cta:hover { background: #4a9010; }',
    '.igbb__cta:disabled { opacity: 0.65; cursor: not-allowed; }',
    '.igbb__trust { display: flex; flex-wrap: wrap; justify-content: center; gap: 6px; font-size: 11.5px; color: #6b7280; }',
    '.igbb__link { display: block; text-align: center; font-size: 12.5px; color: #1E4036; text-decoration: underline; }',
    '.igbb__err:empty { display: none; }',
    '.igbb__err { font-size: 13px; color: #dc2626; text-align: center; }'
  ].join('\n');

  function addStyles() {
    if (document.getElementById('igbb-styles')) return;
    var style = document.createElement('style');
    style.id = 'igbb-styles';
    style.textContent = STYLE;
    document.head.appendChild(style);
  }

  // ─── Helpers ────────────────────────────────────────────────────────────────
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function imgSrc(product) {
    var fi = product.featured_image;
    if (!fi) return '';
    return fi.indexOf('//') === 0 ? 'https:' + fi : fi;
  }

  function variantFor(product, flavor, test) {
    return (product.variants || []).filter(function (v) {
      return v.option1 === flavor && test(v.option2 || '');
    })[0] || null;
  }

  function subVariant(product, flavor) {
    return variantFor(product, flavor, function (o) { return o === 'Subscribe & Save'; });
  }

  function oneTimeVariant(product, flavor) {
    return variantFor(product, flavor, function (o) { return /one\s*time/i.test(o); });
  }

  function planNames(product) {
    var map = {};
    (product.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) { map[p.id] = p.name; });
    });
    return map;
  }

  function planIdsFor(variant) {
    return ((variant && variant.selling_plan_allocations) || []).map(function (a) {
      return a.selling_plan_id;
    });
  }

  // 3-month is the plan the FMD PDPs default to.
  function defaultPlanId(planIds, names) {
    return planIds.filter(function (id) { return /3\s*month/i.test(names[id] || ''); })[0] || planIds[0] || null;
  }

  function closeModal() {
    if (window.DKQuickAdd && typeof window.DKQuickAdd.closeModal === 'function') {
      window.DKQuickAdd.closeModal();
      return;
    }
    var overlay = document.getElementById('cf-modal-overlay');
    if (overlay) {
      overlay.classList.remove('cf-open');
      document.body.style.overflow = '';
    }
  }

  function openCartDrawer() {
    if (window.DKQuickAdd && typeof window.DKQuickAdd.openCartDrawer === 'function') {
      window.DKQuickAdd.openCartDrawer();
      return;
    }
    try {
      if (window.SuperCart && typeof window.SuperCart.ShowCartfn === 'function') {
        window.SuperCart.ShowCartfn();
      } else {
        var btn = document.querySelector('.js-drawer-open-cart');
        if (btn) btn.click();
      }
    } catch (e) {
      console.warn('[FMD BuyBox] Could not open cart drawer', e);
    }
  }

  // ─── State ──────────────────────────────────────────────────────────────────
  var state = { flavor: null, offer: 'sub', plan: null };

  // Selector re-focused after a re-render, so keyboard users don't lose their
  // place when picking a flavor / offer / frequency swaps the markup out.
  var pendingFocus = null;

  // ─── Markup ─────────────────────────────────────────────────────────────────
  function availableFlavors(product, cfg) {
    return cfg.flavOrder.filter(function (f) {
      return subVariant(product, f) || oneTimeVariant(product, f);
    });
  }

  function flavorRowHtml(product, cfg, flavor) {
    var v = subVariant(product, flavor) || oneTimeVariant(product, flavor);
    var label = cfg.flavLabel[flavor] || flavor;
    var desc = cfg.flavDesc[flavor] || '';
    var selected = flavor === state.flavor;
    return '<div class="igbb__row' + (selected ? ' sel' : '') + '" data-flav="' + esc(flavor) + '"' +
      ' role="radio" aria-checked="' + (selected ? 'true' : 'false') + '" tabindex="0">' +
      '<span class="igbb__radio"></span>' +
      '<div class="igbb__rc"><div class="igbb__rt">' + esc(label) + '</div>' +
      (desc ? '<div class="igbb__rd">' + esc(desc) + '</div>' : '') + '</div>' +
      '<div class="igbb__from">From ' + fmt(v.price) + '</div></div>';
  }

  function flavorBlockHtml(product, cfg, flavors) {
    if (flavors.length < 2) return '';
    var rows = flavors.map(function (f) { return flavorRowHtml(product, cfg, f); }).join('');
    return '<div class="igbb__h" id="igbb-flav-label">Choose your flavor:</div>' +
      '<div class="igbb__flavs" role="radiogroup" aria-labelledby="igbb-flav-label">' + rows + '</div>';
  }

  function subscribeRowHtml(o) {
    var saveLine = o.saveAmt
      ? '<div class="igbb__save">' + (o.subCap ? '<span class="cap">' + fmt(o.subCap) + '</span>' : '') +
        fmt(o.subPrice) + ' · Save ' + fmt(o.saveAmt) + ' (' + o.savePct + '% off)</div>'
      : '';
    var freq = (o.selected && o.freqOpts)
      ? '<div class="igbb__freq"><select id="igbb-freq" aria-label="Delivers every">' + o.freqOpts + '</select></div>'
      : '';
    return '<div class="igbb__row' + (o.selected ? ' sel' : '') + '" data-offer="sub">' +
      '<span class="igbb__radio"></span>' +
      '<div class="igbb__rc"' +
        ' role="radio" aria-checked="' + (o.selected ? 'true' : 'false') + '" tabindex="0">' +
        '<div class="igbb__rt">Subscribe &amp; Save <span class="igbb__badge">BEST VALUE</span></div>' +
        saveLine +
        '<ul class="igbb__checks"><li>Free shipping</li><li>Free Welcome Kit ($45 value)</li>' +
        '<li>Flexible — pause, skip, cancel anytime</li></ul>' +
      '</div>' + freq + '</div>';
  }

  function oneTimeRowHtml(selected, price) {
    return '<div class="igbb__row' + (selected ? ' sel' : '') + '" data-offer="ot"' +
      ' role="radio" aria-checked="' + (selected ? 'true' : 'false') + '" tabindex="0">' +
      '<span class="igbb__radio"></span>' +
      '<div class="igbb__rc"><div class="igbb__rt">One-time purchase</div>' +
      '<div class="igbb__rd">' + fmt(price) + '</div></div></div>';
  }

  // ─── Render ─────────────────────────────────────────────────────────────────
  function render(inner, product, cfg) {
    var names = planNames(product);
    var flavors = availableFlavors(product, cfg);
    if (flavors.indexOf(state.flavor) === -1) state.flavor = flavors[0];

    var sv = subVariant(product, state.flavor);
    var ov = oneTimeVariant(product, state.flavor);
    if (!sv) state.offer = 'ot';
    if (!ov) state.offer = 'sub';

    var planIds = planIdsFor(sv);
    if (state.plan === null || planIds.indexOf(state.plan) === -1) {
      state.plan = defaultPlanId(planIds, names);
    }

    var subPrice = sv ? sv.price : 0;
    var subCap = sv ? sv.compare_at_price : null;
    var otPrice = ov ? ov.price : subPrice;
    var isSub = state.offer === 'sub';
    var curPrice = isSub ? subPrice : otPrice;
    var curCap = isSub ? subCap : (ov && ov.compare_at_price);
    var saveAmt = (subCap && subCap > subPrice) ? subCap - subPrice : 0;
    var savePct = saveAmt ? Math.round((subCap - subPrice) / subCap * 100) : 0;

    var src = imgSrc(product);
    var title = DISPLAY_TITLE[product.handle] || product.title;
    var freqOpts = planIds.map(function (id) {
      return '<option value="' + id + '"' + (id === state.plan ? ' selected' : '') + '>' +
        esc(names[id] || 'Plan') + '</option>';
    }).join('');

    var offers = (sv ? subscribeRowHtml({
      selected: isSub, subPrice: subPrice, subCap: subCap,
      saveAmt: saveAmt, savePct: savePct, freqOpts: planIds.length ? freqOpts : ''
    }) : '') + (ov ? oneTimeRowHtml(!isSub, otPrice) : '');

    inner.innerHTML =
      '<div class="igbb">' +
        '<div class="igbb__img"><img src="' + esc(src) + '" alt="' + esc(title) + '"></div>' +
        '<div class="igbb__col">' +
          '<div class="igbb__head">' +
            '<div class="igbb__thumb"><img src="' + esc(src) + '" alt=""></div>' +
            '<div><div class="igbb__title">' + esc(title) + '</div>' +
            '<div class="igbb__rating"><span class="igbb__stars" aria-hidden="true">★★★★★</span>' +
            '<span>' + esc(RATING_TEXT) + '</span></div></div>' +
          '</div>' +
          '<div class="igbb__price"><span class="lbl">Starting at</span>' +
            (curCap && curCap > curPrice ? '<span class="cap">' + fmt(curCap) + '</span>' : '') +
            '<span class="cur">' + fmt(curPrice) + '</span></div>' +
          flavorBlockHtml(product, cfg, flavors) +
          '<div class="igbb__h" id="igbb-offer-label">Choose your offer:</div>' +
          '<div class="igbb__offers" role="radiogroup" aria-labelledby="igbb-offer-label">' + offers + '</div>' +
        '</div>' +
        '<div class="igbb__foot">' +
          '<button type="button" class="igbb__cta" id="igbb-cta">ADD TO CART — ' + fmt(curPrice) + '</button>' +
          '<div class="igbb__trust"><span>HSA/FSA Eligible</span><span>·</span><span>Free Shipping</span>' +
          '<span>·</span><span>25+ Years of Research</span></div>' +
          '<a class="igbb__link" href="/products/' + esc(product.handle) + '">See full product details</a>' +
          '<div class="igbb__err" id="igbb-err" role="alert"></div>' +
        '</div>' +
      '</div>';

    wire(inner, product, cfg, { sub: sv, ot: ov, price: curPrice });

    if (pendingFocus) {
      var refocus = inner.querySelector(pendingFocus);
      if (refocus) refocus.focus();
      pendingFocus = null;
    }
  }

  // ─── Interactions ───────────────────────────────────────────────────────────
  function onActivate(el, handler) {
    el.addEventListener('click', handler);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        handler(e);
      }
    });
  }

  function wire(inner, product, cfg, sel) {
    inner.querySelectorAll('[data-flav]').forEach(function (row) {
      onActivate(row, function () {
        state.flavor = row.getAttribute('data-flav');
        state.plan = null;
        pendingFocus = '[data-flav="' + state.flavor + '"]';
        render(inner, product, cfg);
      });
    });

    inner.querySelectorAll('[data-offer]').forEach(function (row) {
      var offer = row.getAttribute('data-offer');
      var target = row.querySelector('[role="radio"]') || row;
      onActivate(target, function (e) {
        if (e.target && e.target.closest('.igbb__freq')) return;
        state.offer = offer;
        pendingFocus = '[data-offer="' + offer + '"] [role="radio"], [data-offer="' + offer + '"][role="radio"]';
        render(inner, product, cfg);
      });
      if (target !== row) {
        row.addEventListener('click', function (e) {
          if (e.target.closest('.igbb__freq') || e.target.closest('[role="radio"]')) return;
          state.offer = offer;
          render(inner, product, cfg);
        });
      }
    });

    var freq = inner.querySelector('#igbb-freq');
    if (freq) {
      ['mousedown', 'click'].forEach(function (evt) {
        freq.addEventListener(evt, function (e) { e.stopPropagation(); });
      });
      freq.addEventListener('change', function (e) {
        e.stopPropagation();
        state.plan = Number(freq.value);
        pendingFocus = '#igbb-freq';
        render(inner, product, cfg);
      });
    }

    var cta = inner.querySelector('#igbb-cta');
    if (cta) cta.addEventListener('click', function () { addToCart(cta, inner, sel); });
  }

  function addToCart(cta, inner, sel) {
    var isSub = state.offer === 'sub';
    var variant = isSub ? sel.sub : sel.ot;
    if (!variant) return;

    var err = inner.querySelector('#igbb-err');
    cta.disabled = true;
    cta.textContent = 'Adding...';
    if (err) err.textContent = '';

    var body = {
      id: variant.id,
      quantity: 1,
      properties: {
        _flavor: state.flavor,
        _offer: isSub ? 'Subscribe & Save' : 'One-time'
      }
    };
    if (isSub && state.plan) {
      body.selling_plan = state.plan;
      // Matches the PDP: subscriptions get the free Welcome Kit auto-added by
      // the cart drawer (assets/conversion-king-slide-cart.js).
      body.properties._free_welcome_kit = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    }).then(function () {
      closeModal();
      openCartDrawer();
    }).catch(function (e) {
      console.warn('[FMD BuyBox] Add to cart error', e);
      if (err) err.textContent = 'Item could not be added. Please try again.';
      cta.disabled = false;
      cta.textContent = 'ADD TO CART — ' + fmt(sel.price);
    });
  }

  // ─── Quick-Add modal override registration ──────────────────────────────────
  function renderBuyBox(inner, product) {
    var container = document.getElementById('cf-modal-container');
    if (container) container.classList.remove('igbb-host');

    if (!window.matchMedia(DESKTOP_MQ).matches) return false;
    var cfg = product && CONFIG[product.handle];
    if (!cfg) return false;
    // Nothing recognisable to sell (variants renamed?) — let the default
    // modal handle it rather than rendering an empty buy box.
    if (availableFlavors(product, cfg).length === 0) return false;

    addStyles();
    if (container) container.classList.add('igbb-host');
    state.flavor = cfg.defFlav;
    state.offer = 'sub';
    state.plan = null;
    render(inner, product, cfg);
    return true;
  }

  window.DK_QUICK_ADD_OVERRIDES = window.DK_QUICK_ADD_OVERRIDES || [];
  window.DK_QUICK_ADD_OVERRIDES.push(renderBuyBox);
})();
